export default "__VITE_ASSET__Br7JdQ34__"